@if (media?.src) {
  <img
    [attr.src]="media.src"
    [attr.srcset]="media.srcset"
    [attr.alt]="media.alt"
    [attr.loading]="loadingStrategy"
    (load)="loadHandler()"
    (error)="errorHandler()"
    />
}
